import {CheckOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import Flex from 'components/shared-components/Flex';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import React, {useState} from 'react';
import EstService from 'services/EstService';
import HelperService from 'services/HelperService';
import Utils from 'utils';

const PrintedInvoice = ({ id, accessCode, account, customer, invoice }) => {
  const [loading, setLoading] = useState(false);
  const handleDownload = () => {
    const content = document.getElementById('tm_download_section');
    const report = new jsPDF('portrait', 'px', [880, content.clientHeight]);
    report
      .html(document.getElementById('tm_download_section'), {
        width: 880,
        margin: [0, 0, 0, 0],
      })
      .then(() => {
        report.save(`Invoice_${id}_${dayjs().format('DD-MM-YYYY-HH:mm')}.pdf`);
      });
  };

  const handlePay = async () => {
    try {
      setLoading(true);
      // Open payment link
      const res = await EstService.getInvoiceCheckout(id, accessCode);
      window.open(res.data?.url, '_blank');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="tm_container" id="report">
      <div className="tm_invoice_wrap">
        <div className="tm_invoice tm_style1" id="tm_download_section">
          <div className="tm_invoice_in">
            <div className="tm_invoice_head tm_align_center tm_mb20">
              <div className="tm_invoice_left">
                <div className="tm_logo">
                  <img
                    width={51}
                    src={
                      account && account?.invoice_custom_logo_s3_url
                        ? account?.invoice_custom_logo_s3_url
                        : '/img/est-simplified-logo.png'
                    }
                    alt="Logo"
                  />
                </div>
              </div>
              <div className="tm_invoice_right tm_text_right">
                <div className="tm_primary_color tm_f50 tm_text_uppercase">
                  <h1>Invoice</h1>
                </div>
              </div>
            </div>
            <div className="tm_invoice_info tm_mb20">
              <div className="tm_invoice_seperator tm_gray_bg"></div>
              <div className="tm_invoice_info_list">
                <p className="tm_invoice_number tm_m0">
                  Invoice No: <b className="tm_primary_color">#{invoice?.id}</b>
                </p>
                <p className="tm_invoice_date tm_m0">
                  Date:{' '}
                  <b className="tm_primary_color">
                    {dayjs(invoice?.created_at).format('MM-DD-YYYY')}
                  </b>
                </p>
              </div>
            </div>
            <div className="tm_invoice_head tm_mb10">
              <div className="tm_invoice_left">
                <p className="tm_mb2">
                  <b className="tm_primary_color">Invoice To:</b>
                </p>
                <p>
                  {customer?.name} <br />
                  {customer?.address_line_1} <br />
                  {customer?.address_line_2 && (
                    <>
                      {customer?.address_line_2}
                      <br />
                    </>
                  )}
                  {customer?.city}, {customer?.state}, {customer?.zip} <br />
                  {Utils.formatPhoneNumber(customer?.phone ?? '')}
                </p>
              </div>
              <div className="tm_invoice_right tm_text_right">
                <p className="tm_mb2">
                  <b className="tm_primary_color">Pay To:</b>
                </p>
                <p>
                  {account?.invoice_company_name === 'undefined'
                    ? null
                    : account?.invoice_company_name}{' '}
                  <br />
                  {account?.invoice_address_line_1 && (
                    <>
                      {account?.invoice_address_line_1} <br />
                    </>
                  )}
                  {account?.invoice_address_line_2 &&
                    account?.invoice_address_line_2 !== 'null' && (
                      <>
                        {account?.invoice_address_line_2} <br />
                      </>
                    )}
                  {account?.invoice_city ?? 'Missing city'},{' '}
                  {account?.invoice_state ?? 'Missing state'},{' '}
                  {account?.invoice_zip ?? 'Missing ZIP'} <br />
                </p>
              </div>
            </div>
            <div className="tm_table tm_style1">
              <div className="tm_round_border tm_radius_2">
                <div className="">
                  <table className="w-100">
                    <thead>
                      <tr>
                        <th className="tm_width_3 tm_semi_bold tm_primary_color tm_gray_bg px-3 py-2">
                          Item
                        </th>
                        {/*<th className="tm_width_4 tm_semi_bold tm_primary_color tm_gray_bg px-3 py-2">*/}
                        {/*  Description*/}
                        {/*</th>*/}
                        <th className="tm_width_2 tm_semi_bold tm_primary_color tm_gray_bg px-3 py-2">
                          Price
                        </th>
                        <th className="tm_width_1 tm_semi_bold tm_primary_color tm_gray_bg px-3 py-2">
                          Qty
                        </th>
                        <th className="tm_width_2 tm_semi_bold tm_primary_color tm_gray_bg px-3 py-2 tm_text_right">
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoice?.items?.map((i) => (
                        <tr className="tm_table_baseline" key={i.id}>
                          <td className="tm_width_3 tm_primary_color px-3 py-2">
                            {i.name}
                          </td>
                          {/*<td className="tm_width_4 px-3 py-2">{i.name}</td>*/}
                          <td className="tm_width_2 px-3 py-2">
                            {HelperService.currency(i.price)}
                          </td>
                          <td className="tm_width_1 px-3 py-2">{i.qty}</td>
                          <td className="tm_width_2 px-3 py-2 tm_text_right">
                            {HelperService.currency(i.total)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="tm_invoice_footer d-flex flex-row justify-content-end pt-3">
                <div className="tm_right_footer">
                  <table>
                    <tbody>
                      <tr className="">
                        <td className="tm_width_3 tm_primary_color tm_border_none tm_bold">
                          Subtotal
                        </td>
                        <td className="tm_width_3 tm_primary_color tm_text_right tm_border_none tm_bold">
                          {HelperService.currency(invoice?.total)}
                        </td>
                      </tr>
                      {invoice?.discount_percentage > 0 && (
                        <tr className="">
                          <td className="tm_width_3 tm_primary_color tm_border_none tm_pt0">
                            Discount{' '}
                            <span className="tm_ternary_color">
                              (
                              {HelperService.percentage(
                                invoice?.discount_percentage * 100
                              )}
                              )
                            </span>
                          </td>
                          <td className="tm_width_3 tm_text_right tm_border_none tm_pt0">
                            -{HelperService.currency(invoice?.discount_amount)}
                          </td>
                        </tr>
                      )}
                      <tr className="pb-2">
                        <td className="tm_width_3 tm_primary_color tm_border_none tm_pt0">
                          Tax
                        </td>
                        <td className="tm_width_3 tm_primary_color tm_text_right tm_border_none tm_pt0">
                          {HelperService.currency(invoice?.tax)}
                        </td>
                      </tr>
                      <tr className="tm_border_top">
                        <td className="tm_width_3 tm_border_top_0 tm_bold tm_f16 tm_primary_color pt-2">
                          Grand Total
                        </td>
                        <td className="tm_width_3 tm_border_top_0 tm_bold tm_f16 tm_primary_color tm_text_right">
                          {HelperService.currency(invoice?.grand_total)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="tm_round_border tm_radius_2 px-3 py-3 mt-4">
              <p className="tm_mb5">
                <b className="tm_primary_color">Disclaimer:</b>
              </p>
              <p className="tm_m0">{account?.disclaimer}</p>
            </div>
          </div>
        </div>

        {invoice?.status?.name === 'estimate' ||
        invoice?.status?.name === 'approved' ? (
          <Flex
            className="mt-3"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
          >
            {invoice?.status?.name === 'approved' ? (
              <Button
                type="primary"
                shape="round"
                icon={<CheckOutlined />}
                className="ant-button-success"
              >
                Approved
              </Button>
            ) : (
              <Button
                href={`/i/${id}/${accessCode}/approve`}
                type="primary"
                shape="round"
              >
                Approve
              </Button>
            )}
          </Flex>
        ) : null}

        {invoice.payment_enabled &&
        (invoice?.status?.name === 'completed' ||
          invoice?.status?.name === 'overdue') ? (
          <Flex
            className="mt-3"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
          >
            <Button
              type="primary"
              shape="round"
              onClick={handlePay}
              loading={loading}
            >
              Pay
            </Button>
          </Flex>
        ) : null}

        <div className="tm_invoice_btns tm_hide_print">
          <button
            type="button"
            className="tm_invoice_btn tm_color1"
            onClick={() => window.print()}
          >
            <span className="tm_btn_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="ionicon"
                viewBox="0 0 512 512"
              >
                <path
                  d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24"
                  fill="none"
                  stroke="currentColor"
                  strokeLinejoin="round"
                  strokeWidth="32"
                />
                <rect
                  x="128"
                  y="240"
                  width="256"
                  height="208"
                  rx="24.32"
                  ry="24.32"
                  fill="none"
                  stroke="currentColor"
                  strokeLinejoin="round"
                  strokeWidth="32"
                />
                <path
                  d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24"
                  fill="none"
                  stroke="currentColor"
                  strokeLinejoin="round"
                  strokeWidth="32"
                />
                <circle cx="392" cy="184" r="24" fill="currentColor" />
              </svg>
            </span>
            <span className="tm_btn_text">Print</span>
          </button>
          <button
            id="tm_download_btn"
            className="tm_invoice_btn tm_color2"
            onClick={handleDownload}
          >
            <span className="tm_btn_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="ionicon"
                viewBox="0 0 512 512"
              >
                <path
                  d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  strokeLinejoin="round"
                  strokeWidth="32"
                />
              </svg>
            </span>
            <span className="tm_btn_text">Download</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintedInvoice;
